import SavingsGoals from '../components/SavingsGoals';

export default function SavingsGoalsPage() {
  return (
    <div className="container mx-auto px-4 py-8">
      <SavingsGoals />
    </div>
  );
}
